import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { isDemoMode } from './flag'

/** Periodically invalidates the React Query keys the dashboard cares
 *  about so the demo's KPIs visibly tick over time. The demo axios
 *  adapter applies small ± jitter to numeric fields each call, so
 *  invalidation alone is enough to make the screen feel alive in
 *  screenshares. No-op outside demo mode. */
export function useGuardianDemoDriver() {
  const qc = useQueryClient()
  useEffect(() => {
    if (!isDemoMode) return
    const tick = setInterval(() => {
      qc.invalidateQueries({ queryKey: ['dashboard'] })
      qc.invalidateQueries({ queryKey: ['secure-score'] })
      qc.invalidateQueries({ queryKey: ['user-insights'] })
    }, 18_000)
    return () => clearInterval(tick)
  }, [qc])
}
